
import Vue from "vue";

export default Vue.extend({
  name: "ProgressPayments",
  props: ["data", "formatDate"],
  data: () => {
    return {
      processing_fee: 4.75
    };
  }
});
